import React from 'react'
import CourseAsideHero from '../../../reusable/CourseAsideHero'
import CoursesAside from '../../../reusable/Aside-courses'
import CourseCard from '../../../reusable/Course-card'
import { BANKING_BOTTOM_CONTENT, DATA_COURSE_PAGE_3, DATA_DETAILS_PAGE_3, DATA_HERO_PAGE_3 } from '../../../utils/constants'
import Accordian from '../../../reusable/Accordian'
import PageDesc from '../../../reusable/PageDesc'
import { DATA_ACCORDIAN_3 } from '../../../utils/courseConifg'

const DataSciencePage_3 = () => {
  return (
    <div className='outlet-render'>
            <CourseAsideHero {...DATA_HERO_PAGE_3}/>
      <CoursesAside {...DATA_COURSE_PAGE_3}/>
      <CourseCard {...DATA_DETAILS_PAGE_3}/>
      <Accordian {...DATA_ACCORDIAN_3}/>
      <PageDesc {...BANKING_BOTTOM_CONTENT}/>
    </div>
  )
}

export default DataSciencePage_3